import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

function NavDropdownItem({ name, to }) {
	const className = ({ isActive }) =>
		`block px-4 py-2 text-sm transition-colors ${
			isActive
				? 'text-cr-green bg-[--color-bg-secondary]'
				: 'text-[--color-text-secondary] hover:bg-[--color-bg-secondary] hover:text-[--color-text-primary]'
		}`;

	return (
		<li>
			<NavLink to={to} className={className}>
				{name}
			</NavLink>
		</li>
	);
}

NavDropdownItem.propTypes = {
	name: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
};

export default NavDropdownItem;
